import Repository from "./Repository";

export default {
  get() {
    return Repository.get('events')
  },
  getEvent(eventId) {
    return Repository.get('event/' + eventId);
  }
}
